import api from '@/lib/api'

const state = () => ({
  currentService: null,
  currentRequest: {
    name: '',
    phone: '',
    structure_type: '',
    zipcode: '',
    email: '',
    service: {
      service_id: -1,
      service: '',
    }
  },
  allPros: [],
  currentPros: [],

  all: [],
})

const getters = {
  currentService: state => state.currentService,
  currentServiceID: state => state.currentService ? state.currentService.service_id : -1,
  currentRequest: state => state.currentRequest,
  allPros: state => state.allPros,
  currentPros: state => state.currentPros,
  all: state => state.all,
}

const actions = { 
  setCurrentService: ({ commit }, service) => commit('SET_CURRENT_SERVICE', service),
  setCurrentRequest: ({ commit }, request) => commit('SET_CURRENT_REQUEST', request),
  setCurrentPros: ({commit}, pros) => commit('SET_CURRENT_PROS', pros) ,

  // eslint-disable-next-line no-empty-pattern
  async createReferrals({}, referral) {
    const result = await api.post('/referrals', { referral })
    if (result.ok) {
      const newReferralIds = await result.json()
      return { ok: true, created: newReferralIds }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async createReferralsWithNewRequest({}, referral) {
    const result = await api.post('/referrals/with_new_request', { referral })
    if (result.ok) {
      const newReferralIds = await result.json()
      return { ok: true, created: newReferralIds }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadPros ({ commit }, { service_id, structure_type, zipcode } ) {
    const params = new URLSearchParams({ service_id, structure_type, zipcode })

    const result = await api.get('/partners?' + params)
    if (result.ok) {
      const pros = await result.json()
      commit('SET_ALL_PROS', pros)
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async loadExpandedPros ({ }, { excluded_ids = [], limit, service_id, zipcode } ) {
    let params = new URLSearchParams({ limit, service_id, zipcode })
    excluded_ids.forEach( id => params.append('excluded_ids[]', id ))

    const result = await api.get('/partners/expanded?' + params)
    if (result.ok) {
      const pros = await result.json()
      return { ok: true, pros }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_CURRENT_SERVICE: (state, service) => state.currentService = service,
  SET_CURRENT_REQUEST: (state, current_request) => state.currentRequest = current_request,
  SET_CURRENT_PROS: (state, pros) => state.currentPros = pros,
  SET_ALL: (state, referrals) => state.all = referrals,
  SET_ALL_PROS: (state, pros) => state.allPros = pros,

  clearAll(state) {
    state.currentService = null

    state.currentRequest = {
      email: '',
      name: '',
      notes: '',
      phone: '',
      zipcode: '',
      service: {
        service_id: -1,
        service: '',
      },
    }

    state.currentPros = []
    state.allPros = []
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}